import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Mail, Phone } from "lucide-react";
import { INQUIRY_STATUS } from "@/components/InquiriesPanel";

const PROFILE_LABEL = { cedant: "Cédant", acheteur: "Repreneur", autre: "Autre" };

export default function ContactMessagesPanel() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/contact-messages").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    try { await api.patch(`/admin/contact-messages/${id}/status`, { status }); toast.success("Statut mis à jour"); load(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  if (items.length === 0) return <p data-testid="contact-messages-empty" className="text-gray-500 py-10 text-center">Aucun message reçu via la page Contact.</p>;
  return (
    <div data-testid="contact-messages" className="space-y-3">
      {items.map((m) => (
        <div key={m.message_id} data-testid={`contact-msg-${m.message_id}`} className={`bg-white border p-5 ${m.status === "new" ? "border-l-4 border-l-[#E0C173] border-gray-200" : "border-gray-200"}`}>
          <div className="flex justify-between flex-wrap gap-2">
            <div className="font-medium text-[#1B2A4A] flex flex-wrap items-center gap-x-3 gap-y-1">
              {m.name}
              <span className="text-[11px] uppercase tracking-wider bg-[#1B2A4A] text-white px-2 py-0.5">{PROFILE_LABEL[m.profile]}</span>
              <a href={`mailto:${m.email}`} className="text-sm font-normal text-[#475569] inline-flex items-center gap-1 hover:text-[#1B2A4A]"><Mail className="w-3.5 h-3.5" />{m.email}</a>
              {m.phone && <a href={`tel:${m.phone}`} className="text-sm font-normal text-[#475569] inline-flex items-center gap-1 hover:text-[#1B2A4A]"><Phone className="w-3.5 h-3.5" />{m.phone}</a>}
            </div>
            <div className="text-xs text-gray-500">{new Date(m.created_at).toLocaleString("fr-FR")}</div>
          </div>
          <p className="mt-2 text-sm text-[#475569] whitespace-pre-line">{m.message}</p>
          <div className="mt-4 flex flex-wrap gap-2">
            {Object.entries(INQUIRY_STATUS).map(([k, s]) => (
              <button key={k} data-testid={`contact-msg-status-${k}-${m.message_id}`} onClick={() => m.status !== k && setStatus(m.message_id, k)}
                className={`text-xs px-3 py-1 border transition-colors ${m.status === k ? s.cls + " font-semibold" : "border-gray-300 text-gray-600 hover:text-[#1B2A4A] hover:border-gray-400"}`}>{s.label}</button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
